/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetExamTypeDto } from './GetExamTypeDto';
import {
    GetExamTypeDtoFromJSON,
    GetExamTypeDtoFromJSONTyped,
    GetExamTypeDtoToJSON,
} from './GetExamTypeDto';
import type { GetAppointmentChannelDto } from './GetAppointmentChannelDto';
import {
    GetAppointmentChannelDtoFromJSON,
    GetAppointmentChannelDtoFromJSONTyped,
    GetAppointmentChannelDtoToJSON,
} from './GetAppointmentChannelDto';
import type { GetExamDto } from './GetExamDto';
import {
    GetExamDtoFromJSON,
    GetExamDtoFromJSONTyped,
    GetExamDtoToJSON,
} from './GetExamDto';
import type { GetPaymentDto } from './GetPaymentDto';
import {
    GetPaymentDtoFromJSON,
    GetPaymentDtoFromJSONTyped,
    GetPaymentDtoToJSON,
} from './GetPaymentDto';

/**
 * 
 * @export
 * @interface GetVisitRegistrationDto
 */
export interface GetVisitRegistrationDto {
    /**
     * 
     * @type {string}
     * @memberof GetVisitRegistrationDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetVisitRegistrationDto
     */
    firstname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVisitRegistrationDto
     */
    surname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVisitRegistrationDto
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVisitRegistrationDto
     */
    mail?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetVisitRegistrationDto
     */
    visitDateTime?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof GetVisitRegistrationDto
     */
    visitTime?: number | null;
    /**
     * 
     * @type {GetAppointmentChannelDto}
     * @memberof GetVisitRegistrationDto
     */
    appointmentChannel?: GetAppointmentChannelDto | null;
    /**
     * 
     * @type {GetExamTypeDto}
     * @memberof GetVisitRegistrationDto
     */
    examType?: GetExamTypeDto | null;
    /**
     * 
     * @type {GetExamDto}
     * @memberof GetVisitRegistrationDto
     */
    exam?: GetExamDto | null;
    /**
     * 
     * @type {Array<GetPaymentDto>}
     * @memberof GetVisitRegistrationDto
     */
    payments?: Array<GetPaymentDto> | null;
    /**
     * 
     * @type {string}
     * @memberof GetVisitRegistrationDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetVisitRegistrationDto
     */
    online?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetVisitRegistrationDto
     */
    externalBooking?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetVisitRegistrationDto
     */
    invoiceName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVisitRegistrationDto
     */
    invoiceNip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVisitRegistrationDto
     */
    invoiceAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVisitRegistrationDto
     */
    sellDocumentType?: GetVisitRegistrationDtoSellDocumentTypeEnum | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetVisitRegistrationDto
     */
    harmfulFactorsIds?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetVisitRegistrationDto
     */
    active?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetVisitRegistrationDto
     */
    creatorName?: string | null;
}


/**
 * @export
 */
export const GetVisitRegistrationDtoSellDocumentTypeEnum = {
    Paragon: 'Paragon',
    Faktura: 'Faktura'
} as const;
export type GetVisitRegistrationDtoSellDocumentTypeEnum = typeof GetVisitRegistrationDtoSellDocumentTypeEnum[keyof typeof GetVisitRegistrationDtoSellDocumentTypeEnum];


/**
 * Check if a given object implements the GetVisitRegistrationDto interface.
 */
export function instanceOfGetVisitRegistrationDto(value: object): value is GetVisitRegistrationDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetVisitRegistrationDtoFromJSON(json: any): GetVisitRegistrationDto {
    return GetVisitRegistrationDtoFromJSONTyped(json, false);
}

export function GetVisitRegistrationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetVisitRegistrationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'firstname': json['firstname'] == null ? undefined : json['firstname'],
        'surname': json['surname'] == null ? undefined : json['surname'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'mail': json['mail'] == null ? undefined : json['mail'],
        'visitDateTime': json['visitDateTime'] == null ? undefined : (new Date(json['visitDateTime'])),
        'visitTime': json['visitTime'] == null ? undefined : json['visitTime'],
        'appointmentChannel': json['appointmentChannel'] == null ? undefined : GetAppointmentChannelDtoFromJSON(json['appointmentChannel']),
        'examType': json['examType'] == null ? undefined : GetExamTypeDtoFromJSON(json['examType']),
        'exam': json['exam'] == null ? undefined : GetExamDtoFromJSON(json['exam']),
        'payments': json['payments'] == null ? undefined : ((json['payments'] as Array<any>).map(GetPaymentDtoFromJSON)),
        'description': json['description'] == null ? undefined : json['description'],
        'online': json['online'] == null ? undefined : json['online'],
        'externalBooking': json['externalBooking'] == null ? undefined : json['externalBooking'],
        'invoiceName': json['invoiceName'] == null ? undefined : json['invoiceName'],
        'invoiceNip': json['invoiceNip'] == null ? undefined : json['invoiceNip'],
        'invoiceAddress': json['invoiceAddress'] == null ? undefined : json['invoiceAddress'],
        'sellDocumentType': json['sellDocumentType'] == null ? undefined : json['sellDocumentType'],
        'harmfulFactorsIds': json['harmfulFactorsIds'] == null ? undefined : json['harmfulFactorsIds'],
        'active': json['active'] == null ? undefined : json['active'],
        'creatorName': json['creatorName'] == null ? undefined : json['creatorName'],
    };
}

export function GetVisitRegistrationDtoToJSON(value?: GetVisitRegistrationDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'firstname': value['firstname'],
        'surname': value['surname'],
        'phone': value['phone'],
        'mail': value['mail'],
        'visitDateTime': value['visitDateTime'] == null ? undefined : ((value['visitDateTime'] as any).toISOString()),
        'visitTime': value['visitTime'],
        'appointmentChannel': GetAppointmentChannelDtoToJSON(value['appointmentChannel']),
        'examType': GetExamTypeDtoToJSON(value['examType']),
        'exam': GetExamDtoToJSON(value['exam']),
        'payments': value['payments'] == null ? undefined : ((value['payments'] as Array<any>).map(GetPaymentDtoToJSON)),
        'description': value['description'],
        'online': value['online'],
        'externalBooking': value['externalBooking'],
        'invoiceName': value['invoiceName'],
        'invoiceNip': value['invoiceNip'],
        'invoiceAddress': value['invoiceAddress'],
        'sellDocumentType': value['sellDocumentType'],
        'harmfulFactorsIds': value['harmfulFactorsIds'],
        'active': value['active'],
        'creatorName': value['creatorName'],
    };
}

